import React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { axiosInstance_user } from "../../axiosInstance-user";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];
// const validationSchema = Yup.object({

//   payslip: Yup.mixed()
   
//     .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
//       value ? SUPPORTED_FORMATS.includes(value.type) : false
//     ),
//       education_document: Yup.mixed()
  
//     .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
//       value ? SUPPORTED_FORMATS.includes(value.type) : false
//     ),
//      passport: Yup.mixed()
   
//     .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
//       value ? SUPPORTED_FORMATS.includes(value.type) : false
//     ),
//      aadhar_or_pan: Yup.mixed()
    
//     .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
//       value ? SUPPORTED_FORMATS.includes(value.type) : false
//     ),
//     pic_with_front_cam: Yup.mixed()
   
//     .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
//       value ? SUPPORTED_FORMATS.includes(value.type) : false
//     ),

// });
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];

const fileValidation = (fieldLabel) =>
  Yup.mixed().test(
    "fileFormat",
    `${fieldLabel} must be JPG, PNG, or PDF`,
    (value) => {
      if (!value) return true; // allow empty (not required)

      if (value instanceof File) {
        return SUPPORTED_FORMATS.includes(value.type);
      }

      if (typeof value === "string") {
        return (
          value.startsWith("data:image/jpeg") ||
          value.startsWith("data:image/png") ||
          value.startsWith("data:application/pdf") ||
          value.endsWith(".jpg") ||
          value.endsWith(".jpeg") ||
          value.endsWith(".png") ||
          value.endsWith(".pdf")
        );
      }

      return false;
    }
  );



const documentSchema = Yup.object().shape({
  
  payslip: fileValidation("Payslip"),
  education_document: fileValidation("Educational document"),
  passport: fileValidation("Passport"),
  aadhar_or_pan: fileValidation("Aadhaar or PAN"),
  pic_with_front_cam: fileValidation("Front cam pic"),
  payslip_verified: Yup.string().required("Required"),

  
});

export function DocumentInfo() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  const [fileNames, setFileNames] = useState({
    album:"Browse",
    payslip: "Browse",
    education_document: "Browse",
    passport: "Browse",
    aadhar_or_pan: "Browse",
    pic_with_front_cam: "Browse",
  });
  const [previews, setPreviews] = useState({
    album:null,
    payslip: null,
    education_document: null,
    passport: null,
    aadhar_or_pan: null,
    pic_with_front_cam: null,
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileChange = (e, fieldName) => {
    const file = e.currentTarget.files[0];
    setFileNames((prev) => ({
      ...prev,
      [fieldName]: file ? file.name : "Browse",
    }));
    formik.setFieldValue(fieldName, file);
  };

  const formik = useFormik({
    initialValues: {
      album:null,
      payslip: null,
      payslip_verified: "",
      education_document: null,
      education_document_verified: "",
      passport: null,
      passport_verified: "",
      aadhar_or_pan: null,
      aadhar_or_pan_verified: "",
      pic_with_front_cam: null,
      pic_with_front_cam_verified: "",
   
    },
    validationSchema:documentSchema,
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        console.log("EditUser", values);
        const formData = new FormData();
        //Only append the file field if it’s a new file (i.e., of type File). Skip it if it’s an old URL string.
        if (values.album && typeof values.album !== "string") {
          formData.append("album", values.album);
        }
        if (values.payslip && typeof values.payslip !== "string") {
          formData.append("profile[payslip]", values.payslip);
        }
        if (
          values.education_document &&
          typeof values.education_document !== "string"
        ) {
          formData.append(
            "profile[education_document]",
            values.education_document
          );
        }
        if (values.passport && typeof values.passport !== "string") {
          formData.append("profile[passport]", values.passport);
        }
        if (values.aadhar_or_pan && typeof values.aadhar_or_pan !== "string") {
          formData.append("profile[aadhar_or_pan]", values.aadhar_or_pan);
        }
        if (
          values.pic_with_front_cam &&
          typeof values.pic_with_front_cam !== "string"
        ) {
          formData.append(
            "profile[pic_with_front_cam]",
            values.pic_with_front_cam
          );
        }

        formData.append(
          "profile[payslip_verified]",
          Number(values.payslip_verified)
        );
        formData.append(
          "profile[education_document_verified]",
          Number(values.education_document_verified)
        );
        formData.append(
          "profile[passport_verified]",
          Number(values.passport_verified)
        );
        formData.append(
          "profile[aadhar_or_pan_verified]",
          Number(values.aadhar_or_pan_verified)
        );
        formData.append(
          "profile[pic_with_front_cam_verified]",
          Number(values.pic_with_front_cam_verified)
        );

        const response = await axiosInstance_user.patch(
          `/users-profiles/${userId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          setLoading(false); // Stop loader
          handleOpen();
          setTimeout(() => {
            handleClose();
          }, 2000);
          LoadUserProfile(userId);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "");
        console.error("Error while updating", error);
      } finally {
        setLoading(false);
      }
    },
  });
  // get user data
  async function LoadUserProfile(userId) {
    try {
      const response = await axiosInstance_user.get(
        `/users-profiles/${userId}`
      );
      if (response.data.status === "success") {
        // getting few fields from user and few from profile
        const user = response.data.data;
        const profile = user.profile || {};
        setPreviews({
          album:user.album?user.album:null,
          payslip: profile.payslip ? profile.payslip : null,
          education_document: profile.education_document
            ? profile.education_document
            : null,
          passport: profile.passport ? profile.passport : null,
          aadhar_or_pan: profile.aadhar_or_pan ? profile.aadhar_or_pan : null,
          pic_with_front_cam: profile.pic_with_front_cam
            ? profile.pic_with_front_cam
            : null,
        });

        formik.setValues({
          album:user.album || null,
          payslip: profile.payslip || null,
          payslip_verified: profile.payslip_verified ?? "",
          education_document: profile.education_document || null,
          education_document_verified:
            profile.education_document_verified ?? "",
          passport: profile.passport || null,
          passport_verified: profile.passport_verified ?? "",
          aadhar_or_pan: profile.aadhar_or_pan || null,
          aadhar_or_pan_verified: profile.aadhar_or_pan_verified ?? "",
          pic_with_front_cam: profile.pic_with_front_cam || null,
          pic_with_front_cam_verified:
            profile.pic_with_front_cam_verified ?? "",
          password: "nathicharami", // required field
        });
      }
    } catch (err) {
      console.error("Failed to load profile:", err);
    }
  }
  useEffect(() => {
    if (userId) {
      LoadUserProfile(userId);
    }
  }, [userId]);
  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* Row user image  */}
          <div className="doc-subcontainer">
          <div>
            <div className="doc-label">User Image</div>
            <div className="doc-input">
              <label htmlFor="albumInput" className="custom-file-label">
                {fileNames.album}
              </label>
              <input
                type="file"
                id="albumInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "album")}
                accept="image/*"
              />
              {/* image preview */}
              {previews.album &&
                <img
                      src={previews.album}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
               }
              {formik.touched.album && formik.errors.album && (
                <div className="text-danger">{formik.errors.album}</div>
              )}
            </div>
          </div>
          <div>
         {""}
          </div>
        </div>
        {/* Row 1: Payslip */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">Payslip</div>
            <div className="doc-input">
              <label htmlFor="payInput" className="custom-file-label">
                {fileNames.payslip}
              </label>
              <input
                type="file"
                id="payInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "payslip")}
                accept="image/*,application/pdf"
              />
              {/* image preview */}
              {previews.payslip &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.payslip}
                //       alt="Payslip preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.payslip.endsWith(".pdf") ? (
                  <a href={previews.payslip} target="_blank" rel="noreferrer" className="mt-3">
                    View PDF
                  </a>
                ) : (
                  <a href={previews.payslip} target="_blank" rel="noreferrer">
                    <img
                      src={previews.payslip}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.payslip && formik.errors.payslip && (
                <div className="text-danger">{formik.errors.payslip}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">Payslip Verified</div>
            <select
              className="dropdown-btnDoc"
              name="payslip_verified"
              value={formik.values.payslip_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.payslip_verified &&
              formik.errors.payslip_verified && (
                <div className="text-danger">
                  {formik.errors.payslip_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 2: Education */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">Educational Documents</div>
            <div className="doc-input">
              <label htmlFor="eduInput" className="custom-file-label">
                {fileNames.education_document}
              </label>
              <input
                type="file"
                id="eduInput"
                className="custom-file-input"
                accept="image/*,application/pdf"
                onChange={(e) => handleFileChange(e, "education_document")}
              />
              {/* image preview */}
              {previews.education_document &&
                //  (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.education_document}
                //       alt="Education doc preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.education_document.endsWith(".pdf") ? (
                  <a
                    href={previews.education_document}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.education_document}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={previews.education_document}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.education_document &&
                formik.errors.education_document && (
                  <div className="text-danger">
                    {formik.errors.education_document}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="doc-label">Educational Documents Verified </div>
            <select
              className="dropdown-btnDoc"
              name="education_document_verified"
              value={formik.values.education_document_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.education_document_verified &&
              formik.errors.education_document_verified && (
                <div className="text-danger">
                  {formik.errors.education_document_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 3: Passport */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">Passport</div>
            <div className="doc-input">
              <label htmlFor="passportInput" className="custom-file-label">
                {fileNames.passport}
              </label>
              <input
                type="file"
                id="passportInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "passport")}
                accept="image/*,application/pdf"
              />

              {/* image preview */}
              {previews.passport &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.passport}
                //       alt="Passport preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.passport.endsWith(".pdf") ? (
                  <a href={previews.passport} target="_blank" rel="noreferrer" className="mt-3">
                    View PDF
                  </a>
                ) : (
                  <a href={previews.passport} target="_blank" rel="noreferrer">
                    <img
                      src={previews.education_document}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.passport && formik.errors.passport && (
                <div className="text-danger">{formik.errors.passport}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">Passport Verified</div>
            <select
              className="dropdown-btnDoc"
              name="passport_verified"
              value={formik.values.passport_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.passport_verified &&
              formik.errors.passport_verified && (
                <div className="text-danger">
                  {formik.errors.passport_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 4: Aadhar/PAN */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">Aadhaar or PAN</div>
            <div className="doc-input">
              <label htmlFor="aadharInput" className="custom-file-label">
                {fileNames.aadhar_or_pan}
              </label>
              <input
                type="file"
                id="aadharInput"
                className="custom-file-input"
                onChange={(e) => handleFileChange(e, "aadhar_or_pan")}
                accept="image/*,application/pdf"
              />
              {/* image preview */}
              {previews.aadhar_or_pan &&
                //  (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.aadhar_or_pan}
                //       alt="Aadhar preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.aadhar_or_pan.endsWith(".pdf") ? (
                  <a
                    href={previews.aadhar_or_pan}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.aadhar_or_pan}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={previews.aadhar_or_pan}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.aadhar_or_pan && formik.errors.aadhar_or_pan && (
                <div className="text-danger">{formik.errors.aadhar_or_pan}</div>
              )}
            </div>
          </div>
          <div>
            <div className="doc-label">Aadhaar or PAN Verified</div>
            <select
              className="dropdown-btnDoc"
              name="aadhar_or_pan_verified"
              value={formik.values.aadhar_or_pan_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.aadhar_or_pan_verified &&
              formik.errors.aadhar_or_pan_verified && (
                <div className="text-danger">
                  {formik.errors.aadhar_or_pan_verified}
                </div>
              )}
          </div>
        </div>

        {/* Row 5: Pic with front cam */}
        <div className="doc-subcontainer">
          <div>
            <div className="doc-label">Pic with Front Cam</div>
            <div className="doc-input">
              <label htmlFor="frontCamInput" className="custom-file-label">
                {fileNames.pic_with_front_cam}
              </label>
              <input
                type="file"
                id="frontCamInput"
                className="custom-file-input"
                      accept="image/*,application/pdf"
                onChange={(e) => handleFileChange(e, "pic_with_front_cam")}
               
              />
              {/* image preview */}
              {previews.pic_with_front_cam &&
                // (
                //   <div style={{ marginTop: 8 }}>
                //     <img
                //       src={previews.pic_with_front_cam}
                //       alt="Payslip preview"
                //       style={{
                //         maxWidth: 150,
                //         maxHeight: 150,
                //         objectFit: "cover",
                //         borderRadius: 6,
                //       }}
                //     />
                //   </div>
                // )
                (previews.pic_with_front_cam.endsWith(".pdf") ? (
                  <a
                    href={previews.pic_with_front_cam}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3"
                  >
                    View PDF
                  </a>
                ) : (
                  <a
                    href={previews.pic_with_front_cam}
                    target="_blank"
                    rel="noreferrer"
                    
                  >
                    <img
                      src={previews.pic_with_front_cam}
                      alt="Preview"
                      className="image-preview mt-3"
                    />
                  </a>
                ))}
              {formik.touched.pic_with_front_cam &&
                formik.errors.pic_with_front_cam && (
                  <div className="text-danger">
                    {formik.errors.pic_with_front_cam}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="doc-label">Pic with Front Cam Verified</div>
            <select
              className="dropdown-btnDoc"
              name="pic_with_front_cam_verified"
              value={formik.values.pic_with_front_cam_verified}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="2">Pending</option>
              <option value="3">Verified</option>
              <option value="4">Verification Failed</option>
            </select>
            {formik.touched.pic_with_front_cam_verified &&
              formik.errors.pic_with_front_cam_verified && (
                <div className="text-danger">
                  {formik.errors.pic_with_front_cam_verified}
                </div>
              )}
          </div>
        </div>

        {/* Submit Button & Modal */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                Doucment information has been updated successfully 
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
